"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _userNameString = _interopRequireDefault(require("res-extensions/build/userNameString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var user = _ref.user,
    className = _ref.className;
  if (className) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: className
    }, (0, _userNameString["default"])(user));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, (0, _userNameString["default"])(user));
};